import { Avatar } from '@/components/ui/Avatar';
import { useGetUser } from '@/services';
import { getImageUrl } from '@/utils/imageUrl';
import { UserCircle } from 'lucide-react';

interface ConfirmationParticipantsContainerProps {
	participantIds: string[];
}

const ParticipantRow = ({ userId }: { userId: string }) => {
	const { data: user } = useGetUser({ id: userId }, { enabled: !!userId });

	if (!user) {
		return (
			<div className="flex items-center gap-3 py-1.5">
				<div className="flex h-9 w-9 items-center justify-center rounded-full bg-zinc-100 text-zinc-400">
					<UserCircle className="h-5 w-5" />
				</div>
				<span className="text-sm text-zinc-400">Carregando...</span>
			</div>
		);
	}

	const name =
		`${user.first_name ?? ''} ${user.last_name ?? ''}`.trim() || '—';

	return (
		<div className="flex items-center gap-3 py-1.5">
			{user.profile_photo_url ? (
				<Avatar
					img_url={getImageUrl(user.profile_photo_url)}
					variant="circle"
					className="h-9 w-9"
				/>
			) : (
				<div className="flex h-9 w-9 items-center justify-center rounded-full bg-zinc-100 text-zinc-400">
					<UserCircle className="h-5 w-5" />
				</div>
			)}
			<span className="text-sm font-medium text-zinc-900">{name}</span>
		</div>
	);
};

const ConfirmationParticipantsContainer = ({
	participantIds,
}: ConfirmationParticipantsContainerProps) => {
	if (!participantIds?.length) return null;

	return (
		<div className="flex w-full flex-col gap-2">
			<p className="text-[11px] font-semibold uppercase tracking-wide text-zinc-500">
				{participantIds.length === 1
					? 'Paciente'
					: `Participantes (${participantIds.length})`}
			</p>
			<div className="flex flex-col gap-0">
				{participantIds.map((id) => (
					<ParticipantRow key={id} userId={id} />
				))}
			</div>
		</div>
	);
};

export { ConfirmationParticipantsContainer };
